import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

type LineChartProps = {
  dataValues: [];
  title: string;
  yTitle: string;
  seriesName: string;
  intervalPoint: number;
  startPoint: number;
}

export default function LineChartMain(props: LineChartProps) {
  const chartOptions: Highcharts.Options = {
    title: {
      text: props.title
    },
    chart: {
      zoomType: 'x'
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis: {
      title: { text: props.yTitle }
    },
    legend: {
      enabled: false
    },
    series: [{
      type: 'area',
      name: props.seriesName,
      pointInterval: props.intervalPoint,//24 * 3600 * 1000,
      pointStart: props.startPoint,//Date.UTC(2021, 0, 1),
      data: props.dataValues
    }]
  };

  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
      />
    </>
  );
}